/*
 * @Author: cryi.liu
 * @Date: 2020-05-06 14:29:53
 * @LastEditTime: 2020-06-12 16:16:50
 * @Description: view-design 组件库
 */
import {
  Table, Page, RadioGroup, Radio, CheckboxGroup, Checkbox, Button, Input, InputNumber, Icon, Steps,
  Step, Upload, Modal, Tree, Select, Option, Card, Form, FormItem, Spin, Transfer,
} from 'view-design';
import './theme/pss.less';

const Plugin = {
  install: (Vue) => {
    Vue.component('i-table', Table);
    Vue.component('i-page', Page);
    Vue.component('i-radio-group', RadioGroup);
    Vue.component('i-radio', Radio);
    Vue.component('i-checkbox-group', CheckboxGroup);
    Vue.component('i-checkbox', Checkbox);
    Vue.component('i-button', Button);
    Vue.component('i-input', Input);
    Vue.component('i-input-number', InputNumber);
    Vue.component('i-icon', Icon);
    Vue.component('i-steps', Steps);
    Vue.component('i-step', Step);
    Vue.component('i-upload', Upload);
    Vue.component('i-modal', Modal);
    Vue.component('i-tree', Tree);
    Vue.component('i-select', Select);
    Vue.component('i-option', Option);
    Vue.component('i-card', Card);
    Vue.component('i-form', Form);
    Vue.component('i-form-item', FormItem);
    Vue.component('i-spin', Spin);
    Vue.component('i-transfer', Transfer);
  },
};

export default Plugin;
